import React from 'react'
import { SVGIcon } from '~/utils/types'


export const Minus = (props: SVGIcon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={props.fill ? props.fill : "#312E60"}
      fillRule="evenodd"
      d="M26 16c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1s.448-1 1-1h18c.552 0 1 .448 1 1z"
    />
  </svg>
)
